module.exports = __webpack_public_path__ + "static/media/timeline-step-1.f123aa38.png";